import { render } from "./AsahiClose.vue?vue&type=template&id=ceb05c80"
import script from "./AsahiClose.vue?vue&type=script&lang=js"
export * from "./AsahiClose.vue?vue&type=script&lang=js"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__